import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Community} from '../pages/community/classes/community';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/operators';
import {UploadedFile} from '../core/classes/uploaded-file';
import {GenMemberRole} from '../generated/serverModels/GenMemberRole';
import {GenCommunityMember} from '../generated/serverModels/GenCommunityMember';

@Injectable({
  providedIn: 'root',
})
export class CommunityService {

  private readonly baseUrl: string = 'api/community';
  private http = inject(HttpClient);

  constructor() { }

  public getAllCommunities(): Observable<Community[]> {
    return this.http.get<Community[]>(this.baseUrl).pipe(
      map(response => response.map(community => new Community(community))),
    );
  }

  public getCommunityById(id: number): Observable<Community> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<Community>(url).pipe(
      map(community => new Community(community)),
    );
  }

  public requestCommunityAccess(community: Community, reason: string): Observable<unknown> {
    const url = `${this.baseUrl}/${community.id}/request-membership`;
    return this.http.post(url, reason);
  }

  public uploadFiles(files: UploadedFile[], communities: Community[]): Observable<UploadedFile[]> {
    const url = 'api/community/files';
    const formData = new FormData();

    files.forEach(file => {
      formData.append('file', file.file);
    });

    formData.append('communities', JSON.stringify(communities));
    formData.append('fileData', JSON.stringify(files));

    return this.http.post<UploadedFile[]>(url, formData).pipe(
      map(files => files.map(file => new UploadedFile(file))),
    );
  }

  public isCommunityManager(communityId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/${communityId}/manager`);
  }

  public changeUserRole(community: Community, member: GenCommunityMember, role: GenMemberRole): Observable<unknown> {
    const url = `${this.baseUrl}/${community.id}/role?status=${role.toString()}`;
    return this.http.put(url, member);
  }

  public removeUserFromCommunity(community: Community, member: GenCommunityMember): Observable<void> {
    const url = `${this.baseUrl}/${community.id}/${member.userId}`;
    return this.http.delete<void>(url);
  }
}
